<template>
    <span class="org-item">
        <v-tip
            v-if="tips"
            ref="nametip"
            placement="top"
            kind="small"
        >
            <span>{{ tips }}</span>
        </v-tip>
        <v-icon
            v-if="iconName"
            :name="iconName"
        />
        <slot name="text">{{ name }}</slot>
        <v-icon
            v-if="tips"
            v-tip:nametip.hover
            name="org-tips"
            class="org-item-tips"
        />
    </span>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  props: {
    option: {
      type: Object,
      default() {
        return {};
      },
    },

    tips: {
      type: String,
      default: '',
    },
  },

  data() {
    return {};
  },

  computed: {
    name() {
      console.log(1111, this.option);
      return (this.option && this.option.name) || '';
    },

    iconName() {
      const { isFolder, gender, hasSelected, iconName } = this.option || {};
      const iconArr = [];

      if (iconName) {
        return iconName;
      }

      if (isFolder) {
        iconArr.push('depart');
      } else if (parseInt(gender, 10) === 1) {
        iconArr.push('male');
      } else if (parseInt(gender, 10) === 2) {
        iconArr.push('female');
      }

      if (hasSelected) {
        iconArr.push('selected');
      }

      return iconArr.join('-');
    },
  },

  methods: {},
};
</script>

<style lang="less" scoped>
.org-item {
    .v-icon {
        vertical-align: -4px;
        margin-right: 5px;
    }

    &-tips {
        float: right;
        margin-top: 10px;
        width: 16px;
        height: 16px;
        color: #262d3d;
        pointer-events: all;

        // &:hover {
        //     color: #262d3d;
        // }
    }
}
</style>
